module.exports = __webpack_public_path__ + "img/phase2-2015-01-02.8b8238ec.jpg";